export const CONSTS = {
  STORE_KEYS: {
    USER:{
      PROFILE: '__stupf',
      ID: '__stuid',
      TOKEN: '__stutk',
      IP: '__stuip'
    }
  }
}
